const normalizeFlag = (value, defaultValue = 'true') => {
  const source = typeof value === 'string' && value.trim().length ? value : defaultValue;
  return source.toLowerCase() !== 'false';
};

export const auditsEnabled = normalizeFlag(process.env.REACT_APP_ENABLE_AUDITS, 'true');
export const reportsEnabled = normalizeFlag(process.env.REACT_APP_ENABLE_REPORTS, 'true');

export const featureFlags = {
  auditsEnabled,
  reportsEnabled,
};

export default featureFlags;
